import { render } from "./AppInputCheckbox.vue?vue&type=template&id=b38ba684&scoped=true"
import script from "./AppInputCheckbox.vue?vue&type=script&lang=js"
export * from "./AppInputCheckbox.vue?vue&type=script&lang=js"

import "./AppInputCheckbox.vue?vue&type=style&index=0&id=b38ba684&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b38ba684"]])

export default __exports__